const api_config = {
  base_url: window.location.origin,
  auth_token: function () {
    return localStorage.getItem("token");
  },
};

export default api_config;
